module.exports = __webpack_public_path__ + "566d2a0b66db07cac27c732be5340027.svg";